export default __webpack_public_path__ + "static/media/Server-amico.6927d969.svg";